module.exports = __webpack_public_path__ + "images/emoji/kissing_closed_eyes.969ce94888c5c09de055.png";